<template>
  <div>
    <!-- Deltetar Usuário -->
    <v-dialog
      v-model="deleteConfirmation"
      max-width="515"
    >
      <v-card>
        <v-card-title class="mb-3 text-h5 align-center justify-center">
          <span>
            Excluir este usuário?
          </span>
          <br>
          <span>
            Esta ação é irreversível e este usuário será removido permanentemente.
          </span>
        </v-card-title>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            class="rounded-pill"
            color="#F44336"
            @click="deleteConfirmation=false"
          >
            <v-icon
              left
            >
              mdi-cancel
            </v-icon>
            Cancelar
          </v-btn>
          <v-btn
            ref="confirm"
            class="rounded-pill"
            text
            color="#808080"
            @click="agreeDelete()"
          >
            <v-icon
              left
            >
              mdi-thumb-up-outline
            </v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'DeleteUser',
    data () {
      return {
        deleteConfirmation: false,
      }
    },
    methods: {
      ...mapActions('users', ['deleteUser']),
      async delete (id) {
        if (await this.openDeleteConfirmation()) {
          this.deleteUser(id)
          this.$alert('success', 'Conta deletada')
        }
      },
      openDeleteConfirmation () {
        this.deleteConfirmation = true
        return new Promise((resolve) => {
          this.resolve = resolve
        })
      },
      agreeDelete () {
        this.resolve(true)
        this.deleteConfirmation = false
      },
      openDetails (id) {
        this.selectedUser = id
      },
    },
  }
</script>

<style scoped>

.rounded-pill {
  border-radius: 50px !important;
  text-transform: none !important;
  font-weight: 600;
}

</style>
